export class InviteInfo {
  orgname: string;
  inviter: { email: string; firstName: string; lastName: string; zombie: boolean };
}
